import {
  type NativeStackScreenProps,
  type SearchTabNavigatorParams,
} from '#/lib/routes/types'
import {WTRENDS_ENABLED} from '#/env'
import {WSearchScreen} from '#/wsocial/screens/Search/SearchScreen'
import {SearchScreenShell} from './Shell'

export function SearchScreen(
  props: NativeStackScreenProps<SearchTabNavigatorParams, 'Search'>,
) {
  const queryParam = props.route?.params?.q ?? ''

  // When the W Trends service isn't configured for this build (missing API
  // URL/token), fall back to the upstream Bluesky Explore instead of the W
  // Social trends UI, which would otherwise only show an error state.
  if (!WTRENDS_ENABLED) {
    return (
      <SearchScreenShell
        queryParam={queryParam}
        testID="searchScreen"
        isExplore
      />
    )
  }

  return <WSearchScreen queryParam={queryParam} />
}
